import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import { TripDateList } from './trip-date-list'
import { TripDateUpdatePage } from './trip-date-update'
import { TripDatesListPage } from './trip-dates-list'

export const tripDatesRoutes: Route[] = [
  {
    path: Paths.TRIP_DATES_LIST_PAGE,
    element: <TripDatesListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PRIMARY_BOOKED_TRIP_DATES_LIST_PAGE,
    element: <TripDateList variant={'PRIMARY'} />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.SECONDARY_BOOKED_TRIP_DATES_LIST_PAGE,
    element: <TripDateList variant={'SECONDARY'} />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_DATES_UPDATE_PAGE,
    element: <TripDateUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]
